export class InferenceRunError extends Error {
  constructor(message: string) {
    super(message);
    this.name = "InferenceRunError";
  }
}

/**
 * Validation errors are user-friendly and should be displayed to the user
 * so we return the error message directly in the UI
 */
export class ValidationError extends InferenceRunError {
  constructor(message: string) {
    super(message);
    this.name = "ValidationError";
  }
}

export class InsufficientCreditsError extends InferenceRunError {
  constructor(message: string) {
    super(message);
    this.name = "InsufficientCreditsError";
  }
}

export class InvalidAspectRatioError extends ValidationError {
  constructor(aspectRatio: string) {
    super(`Invalid aspect ratio: ${aspectRatio}`);
    this.name = "InvalidAspectRatioError";
  }
}

/**
 * Upstream provider returned an error whose message is safe to surface
 * directly to the user (e.g. "Voice not found"). Extends ValidationError so
 * formatInfoMessage passes the message through unchanged.
 */
export class UpstreamProviderError extends ValidationError {
  constructor(message: string) {
    super(message);
    this.name = "UpstreamProviderError";
  }
}
